import { render, staticRenderFns } from "./CompanyLandingPage.vue?vue&type=template&id=27031d8d&scoped=true"
import script from "./CompanyLandingPage.vue?vue&type=script&lang=js"
export * from "./CompanyLandingPage.vue?vue&type=script&lang=js"
import style0 from "./CompanyLandingPage.vue?vue&type=style&index=0&id=27031d8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27031d8d",
  null
  
)

export default component.exports